import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import socketService from "../services/socketService";
import { useParams } from "react-router-dom";
import { kitchenHandler, authHandler } from "../redux/handlers";
export function useKitchenManagementSocket() {
  const navigate = useNavigate();
  const { businessSlug } = useParams();
  const kitchenIdRef = useRef(null);
  const dispatch = useDispatch();

  const connectManagement = useCallback(
    async (kitchenID) => {
      if (!kitchenID) return;
      kitchenIdRef.current = kitchenID;
      socketService.connect();

      socketService.setKitchenManageMentChannel(kitchenID);
      console.log("เริ่มต้นการตรวจสอบ Kitchen จาก server : ", kitchenID);
      const updateFromKitchenChannel = socketService.registerkitchenManagementChannelHandler(async (msg) => {
        if (msg === "logout") {
          console.log("ได้รับคำสั่ง logout จาก Kitchen server");
          kitchenIdRef.current = null;
          localStorage.removeItem("branchPOSId");
          localStorage.removeItem("email");
          localStorage.removeItem("branchId");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("branchKitchenId");
          socketService.disconnect();
          await dispatch(authHandler.logout(businessSlug));
          await dispatch(kitchenHandler.logoutKitchen(businessSlug, Number(kitchenIdRef.current)));
          navigate(`/${businessSlug}/login`, { replace: true });
        }
      });
      return updateFromKitchenChannel;
    },
    [dispatch, navigate, businessSlug]
  );
  return { connectManagement };
}
